/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @version 1.1.0
 * @since 1.1.0
 */

export const SET_DENSITY_LIST_VIEW = '@@b2b_portal_ui/density/SET_DENSITY_LIST_VIEW';
